<template>
  <VContainer fluid class="secondary ma-0 pa-0" style="background: #3D4A6D">
    <!-- DESKTOP -->
    <VContainer fluid class="d-none d-lg-block">
      <VRow class="justify-center">
        <VCol cols="12" class="text-h2 font-weight-black text-white text-center text-uppercase">
          {{ $t('MENU.faqs') }}
        </VCol>
      </VRow>

      <VRow class="justify-center">
        <VExpansionPanels style="width: 70%;">
          <VCol
            cols="12"
            md="12"
            class="text-center elevation-0"
            v-for="(item, i) in getQuestions"
            :key="i"
          >
            <VExpansionPanel class="mt-4 rounded-lg elevation-0">
              <VExpansionPanelTitle class="font-weight-black text-body-1">
                {{ item.title }}
              </VExpansionPanelTitle>

              <VExpansionPanelText>
                <VCard class="elevation-0" v-if="item?.content && item.content.type === 'text'">
                    <VCardText
                        class="text-left text-body-1"
                        v-for="(line, index) in (item.content.text || [])"
                        :key="index + 9000"
                        v-html="line"
                    />
                </VCard>

                <VCard class="elevation-0" v-else-if="item?.content && item.content.type === 'bullet'">
                    <VCardText class="text-left text-body-1">
                        <ul>
                        <li
                            v-for="(line, index) in (item.content.text || [])"
                            :key="index"
                            v-html="line"
                        />
                        </ul>
                    </VCardText>
                </VCard>
              </VExpansionPanelText>

              <div style="background-color: grey; height: .5px; width: 100%;"></div>
            </VExpansionPanel>
          </VCol>
        </VExpansionPanels>

        <VCol cols="12" md="12" class="text-center mb-6">
          <VBtn
            size="small"
            color="warning"
            class="rounded-xl font-weight-bold"
            @click="moreOrLess"
            
          >
            <span style="color:#fff">{{ maxQuestions >= $t('questions.items').length ? $t('globals.see_less') : $t('globals.see_more') }}</span>
          </VBtn>
        </VCol>
      </VRow>
    </VContainer>

    <!-- MOBILE -->
    <VContainer fluid class="d-sm-none">
      <VRow class="justify-center">
        <VCol cols="12" class="text-h6 text-center text-uppercase">
          {{ $t('MENU.faqs') }}
        </VCol>
      </VRow>

      <VRow class="ma-0 pa-0">
        <VExpansionPanels class="ma-0 pa-0">
          <VCol
            style="width: 100%;"
            cols="12"
            md="6"
            class="ma-0 pa-0 text-center elevation-0"
            v-for="(item, i) in getQuestions"
            :key="i"
          >
            <VExpansionPanel class="mt-4 rounded-lg elevation-0">
              <VExpansionPanelTitle class="font-weight-medium text-body-1">
                {{ item.title }}
              </VExpansionPanelTitle>

              <VExpansionPanelText>
                <VCard class="elevation-0" v-if="item.content.type === 'text'">
                  <VCardText
                    class="text-left text-body-1"
                    v-for="(line, index) in item.content.text"
                    :key="index + 9000"
                    v-html="line"
                  />
                </VCard>

                <VCard class="elevation-0" v-else-if="item.content.type === 'bullet'">
                  <VCardText class="text-left text-body-1">
                    <ul>
                      <li
                        v-for="(line, index) in item.content.text"
                        :key="index"
                        v-html="line"
                      />
                    </ul>
                  </VCardText>
                </VCard>
              </VExpansionPanelText>

              <div style="background-color: grey; height: .5px; width: 100%;"></div>
            </VExpansionPanel>
          </VCol>
        </VExpansionPanels>

        <VCol cols="12" md="12" class="text-center mb-6">
          <VBtn
            size="small"
            color="warning"
            class="rounded-xl font-weight-bold"
            @click="moreOrLess"
          >
            {{ maxQuestions >= $t('questions.items').length ? $t('globals.see_less') : $t('globals.see_more') }}
          </VBtn>
        </VCol>
      </VRow>
    </VContainer>
  </VContainer>
</template>

<script>
export default {
  name: 'FAQS',
  data () {
    return {
      maxQuestions: 5
    }
  },
  computed: {
    getQuestions () {
        // tenta tm (v9), cai para messages, e no fim array vazio
        const raw =
        (this.$tm && this.$tm('questions.items')) ||                     // se $tm existir (Vue I18n v9)
        (this.$i18n?.tm && this.$i18n.tm('questions.items')) ||          // alguns setups expõem via this.$i18n.tm
        (this.$i18n?.messages?.[this.$i18n.locale]?.questions?.items) || // legacy: ler direto das mensagens
        [];

        // garante que seja array
        return Array.isArray(raw) ? raw.slice(0, this.maxQuestions) : [];
    }
  },
  methods: {
    moreOrLess () {
        const all =
        (this.$tm && this.$tm('questions.items')) ||
        (this.$i18n?.tm && this.$i18n.tm('questions.items')) ||
        (this.$i18n?.messages?.[this.$i18n.locale]?.questions?.items) ||
        [];
        const total = Array.isArray(all) ? all.length : 0;

        if (this.maxQuestions >= total) this.maxQuestions = 5
        else this.maxQuestions += 5
    }
  }
}
</script>
